export type Money = number;
export type TaxRate = number;
export enum Currency {
  USD = 'USD',
}
